"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useResizeObserver = _interopRequireDefault(require("./useResizeObserver"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
const useThrottledResizeObserver = _ref => {
  let {
    wait = 250,
    onResize
  } = _ref;
  const [size, setSize] = (0, _react.useState)({
    width: undefined,
    height: undefined,
    top: undefined,
    left: undefined
  });
  const handleResize = (0, _react.useMemo)(() => (0, _throttle.default)(newSize => {
    if (onResize) {
      onResize(newSize);
    }
    setSize(newSize);
  }, wait), [wait, onResize]);
  (0, _react.useEffect)(() => () => {
    if (handleResize) {
      handleResize.cancel();
    }
  }, [handleResize]);
  const {
    ref
  } = (0, _useResizeObserver.default)({
    onResize: handleResize
  });
  return {
    ref,
    width: size.width || 0,
    height: size.height || 0,
    top: size.top || 0,
    left: size.left || 0
  };
};
var _default = exports.default = useThrottledResizeObserver;